import FavoriteListComponent from "./components/favorite-list.component";
var FavoritesListModule = function () {
    var componentSelector = '#shupp-favorites';
    // let favoritesListComponent: FavoriteListComponent;
    var initialize = function () {
        new FavoriteListComponent(componentSelector);
    };
    return {
        init: initialize
    };
};
export default FavoritesListModule();
